import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'; 
import cl from './ModalCars.module.css'
import tbl from '../../../../assets/Style/Table.module.css'

 import { useCar } from '../../../../hooks/useCar';

function ModalCars({ dealerId, amount }) {

    const [isModalOpen, setIsModalOpen] = useState(false);
  
    const [cars, setCars] = useState(null);
    const { carService } = useCar()
   
    useEffect(() => {
        if (isModalOpen) { 
            carService.fetchByDealerId(dealerId)
                .then(cars => setCars(cars))
        }
    }, [isModalOpen]);
 

    return (
        <>
            <button className="close-button" onClick={() => setIsModalOpen(true)} > {amount}$ </button>

            <Modal size="large" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                         შემოსული თანხა დილერის საკომისიოდან
                    </h3>
                </div>

                <div style={{ position: 'relative', display: 'block' }}>

                    <div className={tbl.table }>
                        <table>
                            <thead>
                                <tr>
                                <th className={cl.id} >#</th>
                                <th>ვინი</th>  
                                <th>კლიენტი</th>  
                                <th>თანხა</th>    
                                </tr>
                            </thead>
                            <tbody>
                            {cars ? (
                                            cars.map((car) =>
                                                <tr>
                                                    <td>{car.id}</td>
                                                    <td>{car.vin}</td>
                                                    <td>{car.client.firstname} {car.client.lastname}  </td>
                                                    <td>{car.client_price_dealer} $</td>
                                                </tr>
                                            )
                                        ) : (
                                            <tr>იტვირთება...</tr>
                                        )} 
                            </tbody>
                        </table>
            
                    </div>
  
                </div>
                
            </Modal>

 
        </>
    );
}

export default ModalCars;